import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import { useUpdateOperationModal } from '../context/UpdateOperationModalContext';

const UpdateOperationModalFooter: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useUpdateOperationModal();

  return (
    <Modal.Footer>
      <button
        type="button"
        className="btn btn-lg btn-primary"
        onClick={actions.handleUpdateOperation}
        disabled={!data.hasBeenModified}
      >
        {t('UpdateOperation')}
      </button>
    </Modal.Footer>
  );
};

export default UpdateOperationModalFooter;
